
/* injects from baggage-loader */

'use strict';

export default class AccountSettingsController {

	constructor($log, $state) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;

		this.openMobileMenu = false;
		this.routes = [
			{
				title: 'Profile',
				state: 'account.settings.profile'
			},
			{
				title: 'Password',
				state: 'account.settings.password'
			},
			{
				title: 'Payment Methods',
				state: 'account.settings.payments'
			},
			{
				title: 'Connected Accounts',
				state: 'account.settings.connected-accounts'
			}
		];

	}

	$onInit() {
		
	}

	selectMobileSettings(state) {
		this.openMobileMenu = false;
		this.$state.go(state);
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/settings/account.settings.controller.js